import { useScaffold } from "@Light/scaffold";
import type { InvoiceResponse } from "@Light/services/lightTypes";
import clsx from "clsx";
import { useIsPastDue } from "./common";
import { InvoiceGroup } from "./InvoiceGroup";
import { PastDueNotification } from "./PastDueNotification";

export type BillingContentProps = {
  billingInvoices: InvoiceResponse[];
};

export const BillingContent: React.FC<BillingContentProps> = ({
  billingInvoices,
}) => {
  const firstInvoice = billingInvoices?.[0];
  const isPastDue = useIsPastDue(firstInvoice);
  const upcomingInvoices = billingInvoices.filter(
    (invoice: InvoiceResponse) =>
      !invoice.paid_at && !invoice.is_deferred && !invoice.rebill_invoice,
  );
  const paidInvoices = billingInvoices.filter((invoice: InvoiceResponse) =>
    Boolean(invoice.paid_at || invoice.is_deferred || invoice.rebill_invoice),
  );

  const scaffold = useScaffold();
  if (upcomingInvoices.length === 0 && paidInvoices.length === 0) {
    return (
      <div
        className={clsx(
          "border rounded-lg p-6",
          "flex justify-center",
          "text-sm",
          scaffold.page.colors.text.secondary,
        )}
      >
        No bills yet
      </div>
    );
  }

  const Divided = scaffold.page.divided;
  return (
    <div className="flex flex-col gap-8">
      {isPastDue && <PastDueNotification />}
      <div className="flex flex-col gap-6">
        <Divided>
          {upcomingInvoices.length > 0 ? (
            <InvoiceGroup title="Upcoming" invoices={upcomingInvoices} />
          ) : null}
          {paidInvoices.length > 0 ? (
            <InvoiceGroup title="All payments" invoices={paidInvoices} />
          ) : null}
        </Divided>
      </div>
    </div>
  );
};
